import { Typography } from '@euler/app/components/typography';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import {
  ScoreView,
  useScoreViewMetrics,
} from '@euler/app/tv/components/ScoreView';
import { useTaskInspectionScore } from '@euler/app/tv/functions/useTaskInspectionScore';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { Center } from '@euler/components/Center';
import { useContainerLayout } from '@euler/components/layout/LayoutProvider';
import { isHubBuild } from '@euler/functions/isHub';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import {
  ActivityIndicator,
  Platform,
  StyleProp,
  ViewStyle,
} from 'react-native';

export const WiredTaskInspectionScoreView = memo(
  ({ style }: { style?: StyleProp<ViewStyle> }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    const width = useContainerLayout().width - rpx(30);
    const { taskNo } = useTaskContext();
    const { height } = useScoreViewMetrics({
      width,
    });
    const state = useTaskInspectionScore(taskNo, { refresh: true });

    const score = state.status === 'success' ? state.result! : undefined;
    const error = state.status === 'error' ? state.error : undefined;

    return (
      <Center
        css={`
          width: ${width}px;
          height: ${height}px;
        `}
        style={style}
      >
        {score == null ? (
          error ? (
            <Typography.Label
              regular
              size={rpx(24)}
              color={theme.emptyPlaceholder.errorTextColor}
            >
              加载综合得分失败
            </Typography.Label>
          ) : (
            <ActivityIndicator
              color={theme.emptyPlaceholder.iconColor}
              size={rpx(width / 2)}
            />
          )
        ) : (
          <ScoreView
            width={width}
            height={height}
            score={score}
            outerArcColor={theme.task.score.outerArcColor}
            innerArcBgColor={theme.task.score.innerArcBgColor}
            innerArcColorStops={theme.task.score.innerArcColorStops}
            colorStops={theme.task.score.innerArcColorStops}
            textContainerStyle={
              isHubBuild() && Platform.OS !== 'ios'
                ? undefined
                : {
                    marginTop: rpx(32),
                  }
            }
            textStyle={{
              fontSize: rpx(isHubBuild() && Platform.OS !== 'ios' ? 100 : 88),
              lineHeight: rpx(isHubBuild() && Platform.OS !== 'ios' ? 100 : 88),
              top: rpx(20),
            }}
            labelStyle={{
              fontSize: rpx(24),
              lineHeight: rpx(32),
              color: theme.task.score.labelTextColor,
            }}
            subLabelStyle={{
              fontSize: rpx(16),
              color: theme.task.score.subLabelTextColor,
              lineHeight: rpx(30),
              textTransform: 'uppercase',
            }}
          />
        )}
      </Center>
    );
  },
);
